import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { useParams } from 'react-router';

import { USER_ROLES } from '../../constants';
import UserForm from '../UserForm/UserForm';
import validate from '../../utils/validate';
import { editUserFormYopValidation } from '../UserForm/validation';
import { editUser, getEditableUser } from '../../redux/user-management/userManagementActions';
import { resetEditableUser } from '../../redux/user-management/userManagementReducer';
import CommonPage from '../../components/common-page/CommonPage';

const EditUser = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const editableUser = useSelector((state) => state.userManagement.editableUser);
  const [editUserInitialValus, setEditUserInitialValus] = useState({
    name: '',
    email: '',
    roleName: USER_ROLES.GLOBAL_ADMIN,
  });

  const handleEditUser = useCallback(
    (values) => {
      dispatch(editUser({ id, ...values }));
    },
    [dispatch, id],
  );

  useEffect(() => {
    dispatch(getEditableUser({ id }));

    return () => {
      dispatch(resetEditableUser());
    };
  }, []);

  useEffect(() => {
    setEditUserInitialValus({
      name: editableUser.name ?? '',
      email: editableUser.username ?? '',
      roleName: editableUser.roleName ?? USER_ROLES.GLOBAL_ADMIN,
    });
  }, [editableUser]);

  return (
    <CommonPage>
      <Form
        initialValues={editUserInitialValus}
        onSubmit={handleEditUser}
        validate={(values) => validate(values, editUserFormYopValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <UserForm handleSubmit={handleSubmit} isCreate={false} />}
      />
    </CommonPage>
  );
};

export default EditUser;
